import React, {useState, useEffect, useContext} from "react";
import {useHistory} from "react-router-dom";
import classNames from "classnames";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
} from "reactstrap";

import {
    Tooltip,
    OverlayTrigger
} from "react-bootstrap";

import ReactTable from "components/ReactTable/ReactTable.js";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationAlert from "react-notification-alert";
import rest from "../../API/api";
import { authenticatedFetch } from "../../services/authService";
import { UserLoginContext } from "../../context/UserLoginContext";

const UnprocessedRegistrationsTable = () => {
    const [userState, setUserState] = useContext(UserLoginContext);
    const [alert, setalert] = React.useState(null);
    const [registrations, setRegistrations] = React.useState([]);
    const [data, setData] = React.useState([]);
    const notificationAlertRef = React.useRef(null);
    const history = useHistory();

    console.log('=== UnprocessedRegistrationsTable Component Mounted ===');
    console.log('User Status:', userState.status);
    console.log('User API Key:', userState.apiKey);
    console.log('Registrations state:', registrations);

    // Load unprocessed registrations on mount
    useEffect(() => {
        console.log('=== useEffect fired ===');
        console.log('Conditions check - userState.status:', userState.status);

        if (userState.status) {
            console.log('Conditions met, calling loadRegistrations...');
            loadRegistrations();
        } else {
            console.log('Conditions NOT met, not loading registrations');
        }
    }, [userState.status]);

    const loadRegistrations = async () => {
        try {
            console.log('Loading registrations from:', rest.unprocessedregistrations);

            const response = await authenticatedFetch(rest.unprocessedregistrations, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
            });

            console.log('Response status:', response.status);
            console.log('Response OK:', response.ok);

            if (!response.ok) {
                const errorText = await response.text();
                console.error('API Error:', errorText);
                notify("tc", "danger", `Failed to load registrations: ${response.status}`);
                return;
            }

            const data = await response.json();
            console.log('Registrations loaded:', data.length, 'records');
            console.log('First registration:', data[0]);
            setRegistrations(data);
        } catch (error) {
            console.error('Error loading unprocessed registrations:', error);
            notify("tc", "danger", "Failed to load registrations");
        }
    };

    const notify = (place, color, message) => {
        var type = color;
        var options = {
            place: place,
            message: (
                <div>
                    <div>{message}</div>
                </div>
            ),
            type: type,
            icon: "tim-icons icon-bell-55",
            autoDismiss: 3
        };
        notificationAlertRef.current.notificationAlert(options);
    };

    const _deleteRegistrationAlert = (id, regList, index) => {
        setalert(
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Yes, delete it!"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure?"
                style={{display: "block"}}
                onConfirm={() => _deleteRegistration(id, regList, index)}
                onCancel={() => setalert(null)}
            >
                Are you sure you want to delete this registration? This action cannot be undone.
            </SweetAlert>
        );
    };

    const _deleteRegistration = async (id, regList, index) => {
        setalert(null);
        try {
            const response = await authenticatedFetch(`${rest.unprocessedregistrations}/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
            });

            if (response.ok) {
                const updatedList = await response.json();
                setRegistrations(updatedList);
                notify("tc", "success", "Registration deleted successfully");
            } else {
                notify("tc", "danger", "Failed to delete registration");
            }
        } catch (error) {
            console.error('Error deleting registration:', error);
            notify("tc", "danger", "Error deleting registration");
        }
    };

    const _processRegistration = async (registration) => {
        // Navigate to process registration form
        let tURL = "/admin/processregistration/" + registration._id;
        await history.push(tURL);
    };

    // Update table data whenever registrations change
    useEffect(() => {
        if (registrations && Array.isArray(registrations)) {
            // Sort registrations: unprocessed first (Processed: false/undefined), then processed (Processed: true)
            const sortedRegistrations = [...registrations].sort((a, b) => {
                const aProcessed = a.Processed === true ? 1 : 0;
                const bProcessed = b.Processed === true ? 1 : 0;
                return aProcessed - bProcessed;
            });

            const tableData = sortedRegistrations.map((reg, i) => {
                const submittedDate = reg.createdAt
                    ? new Date(reg.createdAt).toLocaleDateString('en-US')
                    : 'N/A';

                const isProcessed = reg.Processed === true;

                return {
                    id: reg._id,
                    Name: reg.Name || 'N/A',
                    Email: reg.Email || 'N/A',
                    Phone: reg.Phone || 'N/A',
                    EventId: reg.EventId || 'N/A',
                    SignedWaiver: reg.SignedWaiver ? 'Yes' : 'No',
                    Status: isProcessed ? 'Processed' : 'Unprocessed',
                    statusValue: isProcessed ? 1 : 0, // 0 for unprocessed (sort first), 1 for processed
                    Submitted: submittedDate,
                    actions: (
                        <div className="actions-right">
                            {/* View button - show for all registrations */}
                            <OverlayTrigger placement="top" overlay={<Tooltip id={"view_" + i}>View Registration Details</Tooltip>}>
                                <span>
                                <Button
                                    onClick={() => _processRegistration(reg)}
                                    color="info"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like")}
                                >
                                    <i className="tim-icons icon-zoom-split"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            {/* Process button - only show for unprocessed */}
                            {!isProcessed && (
                                <OverlayTrigger placement="top" overlay={<Tooltip id={"process_" + i}>Process Registration</Tooltip>}>
                                    <span>
                                    <Button
                                        onClick={() => _processRegistration(reg)}
                                        color="success"
                                        size="sm"
                                        className={classNames("btn-icon btn-link like")}
                                    >
                                        <i className="tim-icons icon-check-2"/>
                                    </Button>{" "}
                                    </span>
                                </OverlayTrigger>
                            )}
                            {/* Delete button - show for all registrations */}
                            <OverlayTrigger placement="top" overlay={<Tooltip id={"delete_" + i}>Delete Registration</Tooltip>}>
                                <span>
                                <Button
                                    onClick={() => {
                                        const regIndex = sortedRegistrations.findIndex(r => r._id === reg._id);
                                        if (regIndex !== -1) {
                                            _deleteRegistrationAlert(reg._id, sortedRegistrations, regIndex);
                                        }
                                    }}
                                    color="danger"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like")}
                                >
                                    <i className="tim-icons icon-simple-remove"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                        </div>
                    )
                };
            });
            setData(tableData);
        }
    }, [registrations]);

    return (
        <>
            <div className="rna-container">
                <NotificationAlert ref={notificationAlertRef} />
            </div>
            <div className="content">
                <Row>
                    <Col md={12}>
                        <Card>
                            <CardHeader>
                                <CardTitle tag="h4">Event Registrations</CardTitle>
                                <p className="category">Review and process public event registrations (unprocessed shown first)</p>
                            </CardHeader>
                            <CardBody>
                                <ReactTable
                                    data={data}
                                    filterable
                                    resizable={false}
                                    defaultSorted={[
                                        {
                                            id: "statusValue",
                                            desc: false
                                        }
                                    ]}
                                    columns={[
                                        {
                                            Header: "Status",
                                            accessor: "Status",
                                            sortMethod: (a, b) => {
                                                // Sort by unprocessed first
                                                if (a === 'Unprocessed' && b === 'Processed') return -1;
                                                if (a === 'Processed' && b === 'Unprocessed') return 1;
                                                return 0;
                                            },
                                            Cell: row => (
                                                <span className={`badge badge-${row.value === 'Processed' ? 'success' : 'warning'}`}>
                                                    {row.value}
                                                </span>
                                            ),
                                            width: 120
                                        },
                                        {
                                            Header: "statusValue",
                                            accessor: "statusValue",
                                            show: false
                                        },
                                        {
                                            Header: "Name",
                                            accessor: "Name"
                                        },
                                        {
                                            Header: "Email",
                                            accessor: "Email"
                                        },
                                        {
                                            Header: "Phone",
                                            accessor: "Phone"
                                        },
                                        {
                                            Header: "Event ID",
                                            accessor: "EventId"
                                        },
                                        {
                                            Header: "Waiver Signed",
                                            accessor: "SignedWaiver"
                                        },
                                        {
                                            Header: "Submitted",
                                            accessor: "Submitted"
                                        },
                                        {
                                            Header: "Actions",
                                            accessor: "actions",
                                            sortable: false,
                                            filterable: false
                                        }
                                    ]}
                                    defaultPageSize={10}
                                    showPaginationTop
                                    showPaginationBottom={false}
                                    className="-striped -highlight"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
            {alert}
        </>
    );
};

export default UnprocessedRegistrationsTable;
